// extracted by mini-css-extract-plugin
export default {"fieldset":"PaymentMethodView_fieldset__0oDOw","label":"PaymentMethodView_label__YnhZ7","input":"PaymentMethodView_input__xeE5t","select":"PaymentMethodView_select__XZyvo"};